import type { NoticePost } from '../types/board.type.ts';

export const NOTICE_CATEGORY_LABEL: Record<
  NonNullable<NoticePost['category']>,
  string
> = {
  GENERAL: '일반',
  STANDARD: '기준개정',
  WAGE: '임금실태',
  EMERGENCY: '긴급',
};
